import { Link, usePage } from '@inertiajs/react'
import { Activity, Database, FileText, LayoutGrid, Mail, Server, Settings, Users } from 'lucide-react'

import { NavMain } from '@/components/nav-main'
import { NavUser } from '@/components/nav-user'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import {
  adminUsersPath,
  allBackupsPath,
  auditsPath,
  dashboardPath,
  emailSignaturesPath,
  mailerSettingsPath,
  serversPath,
} from '@/routes'
import type { NavItem, SharedData } from '@/types'

import AppLogo from './app-logo'

function getMainNavItems(isSuperadmin: boolean): NavItem[] {
  const items: NavItem[] = [
    {
      title: 'Dashboard',
      href: dashboardPath(),
      icon: LayoutGrid,
    },
    {
      title: 'Servers',
      href: serversPath(),
      icon: Server,
    },
    {
      title: 'Backups',
      href: allBackupsPath(),
      icon: Database,
    },
  ]

  if (isSuperadmin) {
    items.push({
      title: 'Users',
      href: adminUsersPath(),
      icon: Users,
    })
  }

  items.push(
    {
      title: 'Background Jobs',
      href: '/jobs',
      icon: Activity,
      isExternal: true,
    },
    {
      title: 'Audit Log',
      href: auditsPath(),
      icon: FileText,
    },
  )

  return items
}

const settingsNavItems: NavItem[] = [
  {
    title: 'Mailer Settings',
    href: mailerSettingsPath(),
    icon: Mail,
  },
  {
    title: 'Email Signatures',
    href: emailSignaturesPath(),
    icon: Settings,
  },
]

export function AppSidebar() {
  const { auth } = usePage().props as SharedData
  const isSuperadmin = auth.user.role === 'superadmin'
  const mainNavItems = getMainNavItems(isSuperadmin)

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} label="Platform" />
        <NavMain items={settingsNavItems} label="Settings" />
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
